<template>
  <v-container fluid class="environments-container">
    <v-container class="text-center mt-2" v-if="loading">
      <v-progress-circular  
        class="loading"
        indeterminate
        color="#881E98"
      ></v-progress-circular>
    </v-container>
    <v-container v-else>
      <Header name="My environments" @search="onSearch" @sorting="onSort" @filtering="onFilter" />

      <v-container v-if="filteredEnvironments.length === 0">
        <p class="text-center mt-4 font-weight-thin">There are no environments.</p>
      </v-container>

      <v-container v-else id="content-desktop" fluid v-for="environment in filteredEnvironments" :key="environment.Id">
        <EnvironmentItem :environment="environment" @statusChange="statusChange"/>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import Header from '../../core/components/Header/Index';
import EnvironmentItem from './EnvironmentItem';
import { mapActions, mapGetters } from 'vuex';

import { search } from '../../utils/search';

export default {
  data() {
    return {
      loading: true,
      search: '',
      applicationProviders: [],
      sort: '',
      refreshInterval: ''
    }
  },
  components: { Header, EnvironmentItem },
  computed: {
    ...mapGetters(['environments', 'connectedEnvironments']),
    filteredEnvironments() {
       return this.applicationProviders.length ? 
        this.sortEnvironments(search(this.filterEnvironments(), 'EnvironmentName', this.search))
        : this.sortEnvironments(search(this.mergedEnvironments(), 'EnvironmentName', this.search))
    }
  },
  methods: {
    ...mapActions(['getEnvironments', 'testAdmin', 'getConnectedEnvironments' ]),
    onSearch(value) {
      this.search = value
    },
    onSort(sortType) {
      this.sort = sortType;
    },
    sortEnvironments(environments) {
      if(this.sort === 'Newest top')
        return environments.sort((current, next) => current.CreatedAt < next.CreatedAt ? 1 : -1);
      else if(this.sort === 'Oldest top')
        return environments.sort((current, next) => current.CreatedAt > next.CreatedAt ? 1 : -1);
      else if(this.sort === "Alphabetical")
        return environments.sort((current, next) =>
        current.EnvironmentName.toLowerCase() < next.EnvironmentName.toLowerCase() ? -1 
        : current.EnvironmentName.toLowerCase() > next.EnvironmentName.toLowerCase() ? 1 : 0);
      else
        return environments.sort((current, next) =>
        current.EnvironmentName.toLowerCase() > next.EnvironmentName.toLowerCase() ? -1 
        : current.EnvironmentName.toLowerCase() < next.EnvironmentName.toLowerCase() ? 1 : 0);
    },
    onFilter(provider) {
      this.applicationProviders = provider;
    },
    filterEnvironments() {
      const filteredData = [];
      this.applicationProviders.forEach(provider =>
        this.mergedEnvironments().forEach(environment => { 
          if(environment.ApplicationProviderName === provider.title)
            filteredData.push(environment)
      }));
      return filteredData;
    },
    async getPendingStates() {
      const pending = this.mergedEnvironments().find(environment => environment.Status.toLowerCase() !== 'running' && environment.Status.toLowerCase() !== 'stopped');
      console.log('pending', pending)
      if(pending) {
        await this.getEnvironments();
        await this.getConnectedEnvironments();
      } else {
        clearInterval(this.refreshInterval);
        this.refreshInterval = '';
      }
    },
    statusChange() {
      if(!this.refreshInterval) 
        this.refreshInterval = setInterval(() => this.getPendingStates(), 60 * 1000);
    },
    mergedEnvironments() {
      return this.environments.concat(this.connectedEnvironments);
    },
  },
  async beforeMount() {
    await Promise.all([this.getEnvironments(), this.getConnectedEnvironments()]);
    this.loading = false;
  console.log(this.connectedEnvironments)
    this.refreshInterval = setInterval(() => this.getPendingStates(), 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  }
}
</script>

<style>
.environments-container {
  margin-top: 84px;
}

.loading {
  margin-top: 60px;
}
</style>
